exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toogle-el[data-v-c891253e]{ display:none;\n}\n.container-align[data-v-c891253e] {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-around;\n}\r\n", ""]);

// exports
